import React from 'react';

/**
 * Generic empty state shared by the active-users screens.
 * Props: { title, message, icon, hasFilters, onClear }
 */
const EmptyState = ({
  title = 'Nothing to show',
  message,
  icon = '🔍',
  hasFilters = false,
  onClear,
}) => (
  <div className="au-state" data-testid="au-empty">
    <div className="au-state__icon" aria-hidden="true">{icon}</div>
    <p className="au-state__title">{title}</p>
    <p className="au-state__msg">
      {message ||
        (hasFilters
          ? 'No data matches the current filters. Try adjusting or clearing them.'
          : 'There is no activity to show for this view yet.')}
    </p>
    {hasFilters && onClear ? (
      <button type="button" className="au-state__btn" onClick={onClear}>Clear filters</button>
    ) : null}
  </div>
);

export default EmptyState;
